import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';

/**
 * Full-size image modal — used when a member taps a profile picture (avatar or
 * cover): click anywhere / press Escape to close.
 */
export default function ImageLightbox({ src, alt = '', caption = '', onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!src) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center p-4 sm:p-8"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm anim-fade-in" />
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/15 text-white hover:bg-white/25"
        aria-label="Close"
      >
        <FiX className="w-5 h-5" />
      </button>
      <div className="relative m-auto anim-modal flex flex-col items-center gap-3 max-h-full">
        <img
          src={src}
          alt={alt}
          className="max-h-[80vh] max-w-full rounded-2xl shadow-2xl object-contain bg-black"
          onClick={(e) => e.stopPropagation()}
        />
        {caption && (
          <p className="text-white/90 text-sm font-semibold text-center max-w-lg">{caption}</p>
        )}
      </div>
    </div>,
    document.body,
  );
}
